import { Component, Input } from '@angular/core';
import { thirdparty, ThirdPartyService } from 'baseline-lib';
import { DomSanitizer } from '@angular/platform-browser';


/**
 * Generated class for the ThirdPartyHistoryComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'third-party-history',
  templateUrl: 'third-party-history.html'
})
export class ThirdPartyHistoryComponent {

  thirdPartyHistory: thirdparty;
  @Input() gtid: number;

  constructor(public _thirdPartyService : ThirdPartyService, public sanitizer: DomSanitizer) {
    console.log('Hello ThirdPartyHistoryComponent Component');
  }

  ngOnInit() {
    this._thirdPartyService._sharedService.loginSubject.subscribe(
        res => {
            this.thirdPartyHistory = undefined;
                if (!this.thirdPartyHistory)
                    this.getGameHistoryDetails();
        });
      

      this._thirdPartyService.thirdPartyHisSubject.subscribe(
        res => {
            if (res) {
                this.thirdPartyHistory = this._thirdPartyService.selectedGame;
                if (res.responseObj.error) {
                    this._thirdPartyService._sharedService.hideLoader();
                    this._thirdPartyService._sharedService.openLogin.next(true);
                }
                else{
                  this.sanitizeUrl();
                }
                  
            }
        });
      }

      getGameHistoryDetails() {
        this._thirdPartyService.evaluateThirdPartyHistory(this.gtid).subscribe(
            data => {
                this.thirdPartyHistory = data;

                if (data.responseObj.error) {
                    this.thirdPartyHistory.bindingUrl ='';
                    this._thirdPartyService._sharedService.hideLoader();
                    this._thirdPartyService._sharedService.openLogin.next(true);
                }
            });
        this._thirdPartyService._sharedService.hideLoader();
    }


      sanitizeUrl() {
        if (this.thirdPartyHistory.bindingUrl && this.thirdPartyHistory.bindingUrl != '' && !this.thirdPartyHistory.urlSanitize) {
            this.thirdPartyHistory.bindingUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.thirdPartyHistory.bindingUrl);
            this.thirdPartyHistory.urlSanitize = true;
        }
        else if (!this.thirdPartyHistory.urlSanitize) {
            this.thirdPartyHistory.bindingUrl = undefined;
            this.thirdPartyHistory.urlSanitize = false;
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/thirdpartygames/third-party-history/third-party-history.ts